// extracted by mini-css-extract-plugin
module.exports = {"header":"TableChart_header__2wQJd","table":"TableChart_table__3fSM1"};